import { Component, OnDestroy } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule, FormGroupDirective } from '@angular/forms';
import { Subscription, map } from 'rxjs';
import { SupportService } from '../../../../core/services/support.service';
import { UserService } from '@wm-libs/core';
import { AlertService } from '@wm-libs/core';
import { User } from '@wm-libs/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { NgClass, AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss'],
  standalone: true,
  imports: [NgClass, MatCardModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatButtonModule, AsyncPipe, TranslateModule],
})
export class ContactUsComponent implements OnDestroy {
  private userSubscription: Subscription;
  userData$!: User | null;
  contactForm: FormGroup;

  isMobile$ = this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).pipe(map((result) => result.matches));

  constructor(
    private formBuilder: FormBuilder,
    private breakpointObserver: BreakpointObserver,
    private supportService: SupportService,
    private userService: UserService,
    private alertService: AlertService,
    private translateService: TranslateService
  ) {
    this.userSubscription = this.userService.userData$.subscribe((res) => {
      this.userData$ = res;
    });

    this.contactForm = this.formBuilder.group({
      email: [this.userData$?.email || '', [Validators.required, Validators.email]],
      message: ['', Validators.required],
    });
  }

  contact(formDirective: FormGroupDirective): void {
    if (this.contactForm.valid) {
      const { email, message } = this.contactForm.value;

      this.supportService.sendEmail(email, message).subscribe(() => {
        this.alertService.showAlert(this.translateService.instant('CONTACT_US.EMAIL_SENT'), 'success');

        this.contactForm.reset();
        formDirective.resetForm();

        this.contactForm.patchValue({
          email: this.userData$?.email || '',
        });
      });
    } else {
      this.alertService.showAlert(this.translateService.instant('FORMS.NOT_VALID'), 'error');
    }
  }

  ngOnDestroy(): void {
    this.userSubscription.unsubscribe();
  }
}
